import type {
  EmployeeExtendedProfileDTO,
  EmployeeProfileSelfDTO,
  ListEmployeeProfilesQuery,
  ListEmployeeProfilesResult,
  UpsertEmployeeProfileDTO,
  UpdateEmployeeProfileSelfDTO,
} from "@/modules/hr/employee-profile/domain/types";
import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";

const base = `${config.apiUrl}/hr/employees`;

function buildQuery(
  params: Record<string, string | number | boolean | undefined | null>,
): string {
  const s = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v !== undefined && v !== null && v !== "") s.set(k, String(v));
  }
  const q = s.toString();
  return q ? `?${q}` : "";
}

export const employeeProfileApi = {
  list(query: ListEmployeeProfilesQuery): Promise<ListEmployeeProfilesResult> {
    return fetcher.get<ListEmployeeProfilesResult>(
      `${base}${buildQuery({
        offset: query.offset,
        limit: query.limit,
        search: query.search,
        branch: query.branch,
        status: query.status,
        departmentId: query.departmentId,
      })}`,
    );
  },

  getById(userId: string): Promise<EmployeeExtendedProfileDTO> {
    return fetcher.get<EmployeeExtendedProfileDTO>(`${base}/${userId}`);
  },

  upsert(
    userId: string,
    dto: Omit<UpsertEmployeeProfileDTO, "userId" | "actorId">,
  ): Promise<{ id: string }> {
    return fetcher.put<{ id: string }>(`${base}/${userId}/profile`, dto);
  },

  /** Self-view (Employee Portal ก็ใช้ได้) */
  getSelf(): Promise<EmployeeProfileSelfDTO> {
    return fetcher.get<EmployeeProfileSelfDTO>(`${base}/me/profile`);
  },

  /** Self-update: ที่อยู่ปัจจุบัน + เบอร์โทร */
  updateSelf(dto: UpdateEmployeeProfileSelfDTO): Promise<{ success: boolean }> {
    return fetcher.patch<{ success: boolean }>(`${base}/me/profile`, dto);
  },
};
